import {Box} from "@mui/material";
import {EcommerceDashboardDetailHeader} from "./components/ecommerce-dasbhoard-detail-header/EcommerceDashboardDetailHeader";
import {EcommerceDashboardDetailBody} from "./components/ecommerce-dasbhoard-detail-body/EcommerceDashboardDetailBody";

export const EcommerceDashboard = () => {
    return (
        <Box>
            <EcommerceDashboardDetailHeader/>
            <EcommerceDashboardDetailBody/>
        </Box>
    );
};